import createIcon from '../../createIcon';

/**
 * @component @name RollerSkating
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA2LjVDOSA2LjIyIDkuMjIgNiA5LjUgNkgxMi4wMkwxMiA1SDkuNUM5LjIyIDUgOSA0Ljc4IDkgNC41QzkgNC4yMiA5LjIyIDQgOS41IDRIMTJWMUg0VjE2SDIwVjEzLjEyQzIwIDExLjAyIDE4LjQ1IDkuNTkgMTYuOTcgOS4yNEwxNC4yNyA4LjU3QzEzLjQgOC4zNSAxMi43IDcuNzYgMTIuMzIgN0g5LjVDOS4yMiA3IDkgNi43OCA5IDYuNVpNNSAyM0MzLjM0IDIzIDIgMjEuNjYgMiAyMEMyIDE4LjM0IDMuMzQgMTcgNSAxN0M2LjY2IDE3IDggMTguMzQgOCAyMEM4IDIxLjY2IDYuNjYgMjMgNSAyM1pNMTkgMjNDMTcuMzQgMjMgMTYgMjEuNjYgMTYgMjBDMTYgMTguMzQgMTcuMzQgMTcgMTkgMTdDMjAuNjYgMTcgMjIgMTguMzQgMjIgMjBDMjIgMjEuNjYgMjAuNjYgMjMgMTkgMjNaTTEyIDIzQzEwLjM0IDIzIDkgMjEuNjYgOSAyMEM5IDE4LjM0IDEwLjM0IDE3IDEyIDE3QzEzLjY2IDE3IDE1IDE4LjM0IDE1IDIwQzE1IDIxLjY2IDEzLjY2IDIzIDEyIDIzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RollerSkating = createIcon('RollerSkating', [
  [
    'path',
    {
      d: 'M9 6.5C9 6.22 9.22 6 9.5 6H12.02L12 5H9.5C9.22 5 9 4.78 9 4.5C9 4.22 9.22 4 9.5 4H12V1H4V16H20V13.12C20 11.02 18.45 9.59 16.97 9.24L14.27 8.57C13.4 8.35 12.7 7.76 12.32 7H9.5C9.22 7 9 6.78 9 6.5ZM5 23C3.34 23 2 21.66 2 20C2 18.34 3.34 17 5 17C6.66 17 8 18.34 8 20C8 21.66 6.66 23 5 23ZM19 23C17.34 23 16 21.66 16 20C16 18.34 17.34 17 19 17C20.66 17 22 18.34 22 20C22 21.66 20.66 23 19 23ZM12 23C10.34 23 9 21.66 9 20C9 18.34 10.34 17 12 17C13.66 17 15 18.34 15 20C15 21.66 13.66 23 12 23Z',
      key: '16i5ik',
    },
  ],
]);

export default RollerSkating;
